require('./bootstrap');

// závislosty pro web
window.$ = window.jQuery = require('jquery');
require('@popperjs/core');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

require('justifiedGallery');
require('tablesorter');

require('./cookieconsent');
document.body.classList.toggle('c_darkmode');

require('./recaptchaCallbacks');
require('./color-modes');


require('leaflet');

import Cropper from 'cropperjs';
window.cropperjs = Cropper;

import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

$(window).on('load', function() {
    $("#mygallery").justifiedGallery();
});

window.addEventListener("load", function() {
    var cc = initCookieConsent();
    cc.run({
        current_lang: "cs",
        autoclear_cookies: true, // default: false
        page_scripts: true, // default: false
        force_consent: false, // default: false
        gui_options: {
            consent_modal: {
                layout: "cloud", // box/cloud/bar
                position: "bottom center", // bottom/middle/top + left/right/center
                transition: "slide", // zoom/slide
                swap_buttons: false // enable to invert buttons
            },
            settings_modal: {
                layout: "box", // box/bar
                transition: "slide" // zoom/slide
            }
        },

        onAccept: function(cookie) {
            var storages = {};

            if (cookie.level.includes("targeting")) {
                storages.ad_storage = "granted";
            }
            if (cookie.level.includes("analytics")) {
                storages.analytics_storage = "granted";
            }
        },


        onChange: function(cookie, changed_preferences) {
            //
        },

        languages: {
            cs: {
                consent_modal: {
                    title: "Používáme cookies",
                    description:
                        'Soubory cookies 🍪 používáme na tomto webu. Používáním tohoto webu souhlasíte s ukládáním a používáním nezbytných souborů cookies. Zakliknutím tlačítka "Přijmout vše" nám udělíte souhlas k ukládání a používání i dalších souborů cookies jako jsou preferenční, statistické a marketingové a tím Vám můžeme web přizpůsobit na míru Vaším potřebám. <button type="button" data-cc="c-settings" class="cc-link">Nastavení</button>',
                    primary_btn: {
                        text: "Přijmout vše",
                        role: "accept_all" // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: "Odmítnout",
                        role: "accept_necessary" // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: "Nastavení cookies",
                    save_settings_btn: "Uložit nastavení",
                    accept_all_btn: "Přijmout vše",
                    reject_all_btn: "Odmítnout vše",
                    close_btn_label: "Zavřít",
                    cookie_table_headers: [
                        {
                            col1: "Jméno"
                        },
                        {
                            col2: "Doména"
                        },
                        {
                            col3: "Expirace"
                        },
                        {
                            col4: "Popis"
                        }
                    ],
                    blocks: [
                        {
                            title: "Využití cookies",
                            description:
                                'Soubory cookies používáme k zajištění základních funkcí webu jako je přihlášení nebo odesílání jednotlivých formulářů a ke zlepšení vašeho online zážitku. Pro každou kategorii se můžete rozhodnout, zda se chcete přihlásit/odhlásit, a to na základě Vašeho svobodného rozhodnutí.'
                        },
                        {
                            title: "Nezbytné cookies",
                            description:
                                "Tyto soubory cookie jsou nezbytné pro správné fungování webových stránek. Bez těchto cookies by web nefungoval. Nelze je tedy deaktivovat.",
                            toggle: {
                                value: "necessary",
                                enabled: true,
                                readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"
                            }
                        },
                        {
                            title: "Analytické cookies",
                            description:
                                "Analytické cookies nám umožňují měření výkonu našeho webu a případně našich reklamních kampaní. Jejich pomocí určujeme počet návštěv a zdroje návštěv našich internetových stránek. Data získaná pomocí těchto cookies zpracováváme souhrnně, bez použití identifikátorů, které ukazují na konkrétní uživatelé našeho webu. Pokud vypnete používání analytických cookies ve vztahu k Vaší návštěvě, ztrácíme možnost analýzy výkonu a optimalizace našich opatření.",
                            toggle: {
                                value: "analytics",
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                // list of all expected cookies
                                {
                                    col1: "_ga",
                                    col2: ".vlcata.cz",
                                    col3: "2 roky",
                                    col4: "Používá se k rozlišení uživatelů."
                                },
                                {
                                    col1: "_gid",
                                    col2: ".vlcata.cz",
                                    col3: "24 hodin",
                                    col4: "Používá se k rozlišení uživatelů."
                                }
                            ]
                        },
                        {
                            title: "Více informací",
                            description:
                                'Máte-li jakékoli dotazy týkající se našich zásad týkajících se souborů cookies a Vašich zvolených preferencí, <a class="cc-link" href="mailto:adam@vlcata.cz">kontaktujte nás</a>.'
                        }
                    ]
                }
            }
        }
    });
});

